const footCols: { title: string; links: string[] }[] = [
  { title: '内容题材', links: ['今日曝光', '刚刚流出', '新鲜黑料', '商务风向', '考古时间线'] },
  { title: '围观入口', links: ['主角档案', '热议风向', '追更提醒', '曝料投稿'] },
];

export default function Footer() {
  return (
    <footer className="mt-8 border-t border-background-200/70 bg-secondary-50">
      <div className="mx-auto w-full max-w-[1440px] px-4 py-8 md:px-6 md:py-10">
        <div className="flex flex-col gap-8 lg:flex-row lg:justify-between">
          <div className="max-w-sm">
            <div className="flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-base"></i>
              </span>
              <span className="font-heading text-lg text-foreground-950">最新黑料</span>
            </div>
            <p className="mt-3 text-[12px] leading-relaxed text-secondary-700">
              今日最新黑料持续更新，刚刚流出的新鲜黑料与今日新料即时汇总，追踪最新黑料今日曝光不迷路。
            </p>
            <div className="mt-4 flex gap-2">
              {['ri-weibo-line', 'ri-twitter-x-line', 'ri-telegram-line', 'ri-rss-fill'].map((ic) => (
                <a key={ic} href="#top" className="flex h-8 w-8 items-center justify-center rounded-lg border border-background-300/70 bg-background-50 text-secondary-700 transition-colors hover:border-primary-300 hover:text-primary-600">
                  <i className={`${ic} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          <div className="flex flex-wrap gap-8">
            {footCols.map((col) => (
              <div key={col.title}>
                <h4 className="mb-3 text-[13px] font-bold text-foreground-900">{col.title}</h4>
                <ul className="space-y-2">
                  {col.links.map((l) => (
                    <li key={l}>
                      <a href="#top" className="text-[12px] text-secondary-700 transition-colors hover:text-primary-600">{l}</a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
            <div>
              <h4 className="mb-3 text-[13px] font-bold text-foreground-900">内容说明</h4>
              <p className="max-w-[200px] text-[11px] leading-relaxed text-secondary-600">
                本站为信息聚合展示，内容仅供围观参考，请理性吃瓜、等待各方回应。
              </p>
            </div>
          </div>
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-2 border-t border-background-300/60 pt-4 sm:flex-row">
          <p className="text-[11px] text-secondary-600">© 2026 最新黑料 · 今日曝光新料即时更新</p>
          <p className="flex items-center gap-1 text-[11px] text-secondary-600">
            <i className="ri-time-line text-[12px]"></i> 页面快讯每 5 分钟刷新一次
          </p>
        </div>
      </div>
    </footer>
  );
}